import React from 'react';
import PropTypes from 'prop-types';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';

function getStyles(__, { palette = {} }) {
  return {
    errorContainer: {
      color: palette.redDark,
      fontSize: 12, // If not set, the default font size is 14px
    },
  };
}

function Error(props) {
  const { classes, message } = props;

  return (
    <div className={`error ${classes.errorContainer}`} role="alert">
      {message}
    </div>
  );
}

Error.propTypes = {
  classes: PropTypes.shape({}).isRequired,
  message: PropTypes.string,
};

Error.defaultProps = {
  message: '',
};

const Wrapped = withDefaultStyles(Error, getStyles);

export { Wrapped as Error };
